import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Translation, Locale } from 'locale'
import { WindowActions } from 'epics/windowEpic'
import { HeroPanel, EnvironmentTitle, DetailTilesContainer, BannerTilesGroup, BannerStatusTile } from 'view/shared/heroPanel'
import { OrganisationDetail, UserDetail, CollateralDetail, TradingEntityDetail, FatFingerDetail } from 'api'
import { organisationDetailsSelector } from 'selectors/organisationSelectors'
import { allTradingEntityDetailsSelector } from 'selectors/tradingEntitySelectors'
import { createCollateralDetailsSelector } from 'selectors/collateralSelectors'
import { userDetailsSelector } from 'selectors/userSelectors'
import { fatFingerDetailsSelector } from 'selectors/fatFingerSelectors'

export interface PlatformHeroPanelProps {
  organisationList: OrganisationDetail[]
  tradingEntityList: TradingEntityDetail[]
  userList: UserDetail[]
  collateralList: CollateralDetail[]
  fatFingerList: FatFingerDetail[]
  onTearout: () => void
}

const mapStateToProps = createStructuredSelector({
  organisationList: organisationDetailsSelector,
  tradingEntityList: allTradingEntityDetailsSelector,
  userList: userDetailsSelector,
  collateralList: createCollateralDetailsSelector(),
  fatFingerList: fatFingerDetailsSelector
})

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/admin/platform')
}

export const PlatformHeroPanelComponent: React.FunctionComponent<PlatformHeroPanelProps> = props => {
  const { onTearout, organisationList, tradingEntityList, userList, collateralList, fatFingerList } = props
  return (
    <HeroPanel onTearout={onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'PlatformHeroPanel-EnvironmentTitle'}>
          {Locale.translate(Translation.TC_HERO_PLATFORM)}
        </EnvironmentTitle>

        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_SUMMARY)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_HERO_ORGANISATIONS)} label={organisationList.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_HERO_TRADING_ENTITIES)} label={tradingEntityList.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_HERO_USERS)} label={userList.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_HERO_COLLATERALS)} label={collateralList.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_HERO_FAT_FINGER_LIMITS)} label={fatFingerList.length} />
        </BannerTilesGroup>
      </DetailTilesContainer>
    </HeroPanel>
  )
}

export const PlatformHeroPanel = connect(mapStateToProps, mapDispatchToProps)(PlatformHeroPanelComponent)
